module.exports = __webpack_public_path__ + "img/fb89232.png";